import consumer from "./consumer"

export function createWebsocketProxy(streamSessionId, onMessage, onError, onConnected, onClose) {
  let subscription;
  console.log(`Creating websocket proxy with ${streamSessionId}`);

  subscription = consumer.subscriptions.create(
    { channel: "WebsocketProxyChannel", stream_session_id: streamSessionId },
    {
      connected() {
        if (onConnected) onConnected();
        console.log("Connected to WebsocketProxyChannel");
      },
      
      disconnected() {
        console.log("Disconnected from WebsocketProxyChannel");
        if (onClose) onClose();
      },
      
      received(data) {
        if (data.error) {
          if (onError) onError(data.error);
        } else if (data.closed) {
          if (onClose) onClose(data.code, data.reason);
        } else {
          console.log("Received from Server:", data);
          if (onMessage) onMessage(data);
        }
      },
      
      send_message(data) {
        // console.log("Sending data to server:", data);
        this.perform('receive', data);
      }
    }
  );

  return {
    send: (data) => subscription.send_message(data),
    close: () => subscription.unsubscribe()
  };
}